import { render, staticRenderFns } from "./LinkQR036.vue?vue&type=template&id=41dda20b&scoped=true&"
import script from "./LinkQR036.vue?vue&type=script&lang=js&"
export * from "./LinkQR036.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR036.vue?vue&type=style&index=0&id=41dda20b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dda20b",
  null
  
)

export default component.exports